/**
 * 京都府 名物めし 12段階（コンテンツデータ）。
 *
 * 数値（radius / mass / score / unlockScore）は他県と同じテンプレート。
 * 12品すべてが農水省「うちの郷土料理」京都府の30品から採ってある。
 *
 * 京都市に偏らせていない。京都市6品、宇治田原町・京丹波町・南丹市美山・舞鶴市・
 * 長岡京市ほか西山・府内全域で6品。
 *
 * へしこは使わない。
 *  福井（Lv10 へしこ）とまったく同じ料理名になる。丹後の枠は、はもの焼き物（Lv11）で確保した。
 *
 * にしんそばは使わない。
 *  農水省の京都府一覧に独立項目がなく（「にしん茄子」ページ本文で言及されるのみ）、
 *  そばは福井・山形・島根・徳島ですでに4品ある。丼に入った茶色いつゆのそばは盤面で見分けにくい。
 *
 * 湯豆腐も使わない。
 *  農水省の京都府一覧になく、府・市の公式にも解説ページが見つからなかった。
 *  出典の質が他の11品に届かない。
 *
 * 形のばらつき。
 *  細かい葉が低く広がる（山椒の佃煮）／半月の薄切り（すぐき漬）／角ばった小片（しば漬）／
 *  長い千切りが絡む（古老柿なます）／大粒の球が一層（黒豆）／平たい円盤（とち餅）／
 *  15センチの細長い莢（万願寺）／平たい直角三角形（水無月）／くさび形が立つ（木の芽和え）／
 *  直径8センチの薄い円盤（千枚漬）／長い一枚の白身（はも）／輪切りが一列（鯖寿司）。
 *  器を描く例外はない。
 *
 * 調査で出てきた「書いてはいけないこと」を反映している。
 *  - 南禅寺水路閣は「国宝」と書かない。文化審議会の答申の段階。明治21年の建造とだけ書く。
 *  - 天橋立の「日本三景」「特別名勝」は国・府の公式で確認できない。書かない。
 *  - 「日本一」「日本最古」「日本最初」は京都では主張が多い。公式の断定形がある場合だけ使う。
 *  - 「京都三大漬物」は農水省のしば漬けページにあるので使えるが、「日本三大」に言い換えない。
 *  - 堂内の仏像・障壁画は著作権と信仰の両面から描かせない。建物の外観だけを描く。
 *  - 小説・映画・アニメ作品と結びつけない。宇治で源氏物語に触れない。
 *
 * 本番画像は public/assets/foods/kyoto/ に置く。
 *
 * 2026-10-02 確定案（audit/_確定案.csv）で料理を入れ替えた。
 * - 外した品：山椒の葉の佃煮・すぐき漬け・しば漬け・古老柿なます・黒豆煮・とち餅・万願寺とうがらしとじゃこの炊いたん・水無月・たけのこの木の芽和え・千枚漬け（店で食べられる品に差し替え）
 * - 衣笠丼：名前の由来（衣笠山）は書かない。公式で確かめられていない
 * - 衣笠丼：【暫定】公式の出典が見つかっていない。説明は絵の内容に沿った一般的な記述だけにした。出典が見つかるまで仮の文（2026-10-02）
 * - 海軍肉じゃが：「肉じゃが発祥の地」とは書かない。舞鶴観光協会は「舞鶴発祥『肉じゃが』」と書くが、国・自治体の資料で裏が取れていない（CLAUDE.md の発祥の方針）
 * - 海軍肉じゃが：東郷平八郎がビーフシチューをもとに作らせた、という話は書かない。市民有志の実行委員会のページにしかない
 * - 海軍肉じゃが：教科書が「全国で舞鶴にしか残っていない」は書かない。実行委員会の主張で、公的資料で確かめていない
 * - けいらんうどん：名前の由来（鶏卵）や考案の由来は書かない。出典にない
 * - 茶そば：「抹茶を生地に練り込む」という作り方は書かない。開いた公式ページは「抹茶使用の茶そば」までで、作り方の記述がない
 * - 茶そば：茶そばの歴史・由来・宇治名物としての位置づけは書かない。公式資料で確かめられない
 * - 茶そば：出典ページの店名・創業年・値段は書かない（店名を出さない決まり）
 * - 京都ラーメン（背脂醤油）：店名と創業年（「最も古いといわれる」店が1938年創業など）は書かない。店名を出さない方針と、「最古」型の主張のため
 * - 京都ラーメン（背脂醤油）：九条ねぎをのせるとは書かない。出典に九条ねぎの語がない
 * - 抹茶パフェ（特選都路里パフェ）：商品名（特選都路里パフェ）と店名は書かない。特定の店の商品名になるため
 * - 抹茶パフェ（特選都路里パフェ）：抹茶パフェの発祥・考案者・始まった年は書かない。公式資料で確かめられない
 * - 抹茶パフェ（特選都路里パフェ）：あんこ・白玉・栗・生クリームなど、絵にある具の名前は書かない。出典の冊子で抹茶パフェの具として確かめられるのは抹茶カステラと抹茶ゼリーだけ
 * - にしんそば：「発祥の店」「元祖」は書かない
 * - にしんそば：にしんを甘露煮にすることは書かない。農水省で甘露煮の手順があるのは北海道のニシン蕎麦のページで、京都のにしんそばの作り方としては確かめていない
 * - 湯豆腐：「南禅寺・嵯峨野の湯豆腐」とは書かない。開いた公式ページ（京都市観光協会・南禅寺公式トップ）で確かめられていない
 * - 湯豆腐：昆布だしで煮ることは書かない。出典にない
 */

import { attachHulls } from '../../utils/itemShape';
import type { RewardLink, StageDefinition, StageItemDefinition } from '../types';

import { kyotoSceneryTour } from './kyotoScenes';
import { KYOTO_FOOD_HULLS } from './kyotoFoodShapes.generated';

/** 「食べに行く」導線の既定リンク（特定店の宣伝にならないよう検索リンクにする）。 */
function searchLinks(area: string, dish: string): RewardLink[] {
  return [
    {
      label: '地図で探す',
      url: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${area} ${dish}`)}`,
    },
    {
      label: 'お店を調べる',
      url: `https://www.google.com/search?q=${encodeURIComponent(`${area} ${dish}`)}`,
    },
  ];
}

const FOOD_ITEMS: StageItemDefinition[] = [
  {
    id: 'kinugasa-don',
    level: 1,
    name: '衣笠丼',
    shortName: '衣笠丼',
    image: '/assets/foods/kyoto/01_kinugasa_don.webp',
    radius: 17,
    mass: 1,
    score: 2,
    description: '甘辛く煮た油揚げと九条ねぎを、だしで煮て卵でとじ、ご飯にのせる丼。肉を使わず、黄色い卵と茶色の揚げと緑のねぎの色で器が埋まる。',
    icon: { label: '衣笠丼', shape: 'rice-bowl', baseColor: '#e8c050', accentColor: '#4a8a2a' },
    reward: {
      unlockScore: 200,
      area: '京都市',
      headline: '油揚げとねぎの卵とじ丼',
      tip: '京都のうどん屋やそば屋で、きつねうどんと並ぶ品書きとして出されることが多い。',
      links: searchLinks('京都市', '衣笠丼'),
    },
  },
  {
    id: 'kaigun-nikujaga',
    level: 2,
    name: '海軍肉じゃが',
    shortName: '海軍肉じゃが',
    image: '/assets/foods/kyoto/02_kaigun_nikujaga.webp',
    radius: 21,
    mass: 1.3,
    score: 4,
    description: '舞鶴に残る旧海軍の料理教科書のとおりに作る肉じゃが。材料は牛肉・こんにゃく・じゃがいも・玉ねぎで、胡麻油に牛肉を入れ、砂糖、醤油の順に加え、こんにゃくとじゃがいも、最後に玉ねぎを入れて仕上げる。',
    source:
      'https://nikujyaga.info/%e5%85%83%e7%a5%96%e8%82%89%e3%81%98%e3%82%83%e3%81%8c%e3%83%ac%e3%82%b7%e3%83%94/',
    icon: { label: '肉じゃが', shape: 'pot', baseColor: '#c89858', accentColor: '#8a4a2a' },
    reward: {
      unlockScore: 500,
      area: '舞鶴市',
      headline: '海軍の教科書どおりに煮る',
      tip: '海軍厨業管理教科書は舞鶴の海上自衛隊第四術科学校の図書館に残っており、肉じゃがは「甘煮」の名で書かれている。',
      links: searchLinks('舞鶴市', '海軍肉じゃが'),
      official: [{ label: '舞鶴観光協会「舞鶴赤れんがパーク」', url: 'https://maizuru-kanko.net/recommend/akarenga' }],
    },
  },
  {
    id: 'keiran-udon',
    level: 3,
    name: 'けいらんうどん',
    shortName: 'けいらんうどん',
    image: '/assets/foods/kyoto/03_keiran_udon.webp',
    radius: 26,
    mass: 1.7,
    score: 8,
    description: '京都のうどん屋に並ぶ、あんかけのうどんの一つ。けいらんはあんかけの「卵とじ」で、だしの効いたあつあつのあんに、付きもののおろししょうがを添えて食べる。',
    source:
      'https://plus.kyoto.travel/entry/kyotofoodculture1_kihon',
    icon: { label: 'けいらん', shape: 'noodle-bowl', baseColor: '#f0d878', accentColor: '#e8a040' },
    reward: {
      unlockScore: 1000,
      area: '京都市',
      headline: 'あんでとじた卵のうどん',
      tip: '京都のうどん屋には、具ののったあんかけの「のっぺい」、刻んだ油揚げをあんでとじた「たぬき」もある。底冷えのする冬に体の芯から温まる。',
      links: searchLinks('京都市', 'けいらんうどん'),
    },
  },
  {
    id: 'cha-soba',
    level: 4,
    name: '茶そば',
    shortName: '茶そば',
    image: '/assets/foods/kyoto/04_cha_soba.webp',
    radius: 30,
    mass: 2.2,
    score: 16,
    description: '抹茶を使って作るそば。宇治では、宇治橋と宇治川を眺める茶屋の茶房や宇治川沿いの茶店で、抹茶スイーツや宇治茶と並んで茶そばが出される。有機栽培の抹茶を使うものもある。',
    source:
      'https://www.kyoto-kankou.or.jp/info_search/3271',
    icon: { label: '茶そば', shape: 'noodle-bowl', baseColor: '#8aa860', accentColor: '#3a5a2a' },
    reward: {
      unlockScore: 1800,
      area: '宇治市',
      headline: '宇治川沿いの茶房で食べる抹茶のそば',
      tip: '宇治茶は、京都・奈良・滋賀・三重の4府県産の茶葉を、京都府内の業者が宇治地域に由来する製法で仕上げた緑茶。抹茶は碾茶を粉にしたもの。',
      links: searchLinks('宇治市', '茶そば'),
      official: [{ label: '京都府観光連盟（宇治川沿いの茶店のページ。各種茶そば）', url: 'https://www.kyoto-kankou.or.jp/info_search/9620' }],
    },
  },
  {
    id: 'kyoto-ramen',
    level: 5,
    name: '京都ラーメン（背脂醤油）',
    shortName: '京都ラーメン',
    image: '/assets/foods/kyoto/05_kyoto_ramen.webp',
    radius: 36,
    mass: 2.8,
    score: 32,
    description: '京都の老舗ラーメン店からは、豚骨に醤油を合わせたコクのあるスープの店や、「背脂チャッチャ系」を生んだ店が登場した。屋台から始まり、先駆けとなった老舗はいまも愛されている。',
    source:
      'https://plus.kyoto.travel/entry/food-culture-ramen',
    icon: { label: '京都ラーメン', shape: 'ramen', baseColor: '#6a3a20', accentColor: '#5a9a3a' },
    reward: {
      unlockScore: 3000,
      area: '京都市',
      headline: '豚骨醤油に背脂のラーメン',
      tip: '麺の硬さや、ねぎ・もやしの量を調整できるのも昔ながらの京都ラーメンの特徴とされる。いまは濃厚な鶏白湯系や澄んだ清湯系の店も増えている。',
      links: searchLinks('京都市', '京都ラーメン 背脂醤油'),
    },
  },
  {
    id: 'matcha-parfait',
    level: 6,
    name: '抹茶パフェ（特選都路里パフェ）',
    shortName: '抹茶パフェ',
    image: '/assets/foods/kyoto/06_matcha_parfait.webp',
    radius: 42,
    mass: 3.5,
    score: 64,
    description: '宇治抹茶を使ったパフェ。抹茶カステラや手作りの抹茶ゼリーなどを器に盛り込む。宇治市や京都市内の宇治茶カフェ認定店の案内冊子には、宇治茶とともに抹茶パフェを出す店がいくつも載っている。',
    source:
      'https://www.pref.kyoto.jp/yamashiro/ocha/news/documents/ujicha_cafe_guide2026.pdf',
    icon: { label: '抹茶パフェ', shape: 'berry', baseColor: '#6a9a3a', accentColor: '#f4ecd8' },
    reward: {
      unlockScore: 4500,
      area: '京都市／宇治市',
      headline: '宇治茶カフェで出る抹茶のパフェ',
      tip: '抹茶は碾茶を粉にしたもの。京都の宇治茶は、近年は飲むだけでなく抹茶スイーツなどの加工品が多く作られ、世代を超えたファンを集めている。',
      links: searchLinks('京都市', '抹茶パフェ'),
      official: [{ label: '農林水産省「うちの郷土料理」宇治金時（宇治抹茶はゼリーやアイスなどにも使われる）', url: 'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/ujikintoki_kyoto.html' }],
    },
  },
  {
    id: 'yuba-don',
    level: 7,
    name: '湯葉丼',
    shortName: '湯葉丼',
    image: '/assets/foods/kyoto/07_yuba_don.webp',
    radius: 46,
    mass: 4.4,
    score: 128,
    description: '京湯葉は、大豆を挽いて絞った豆乳を湯せんし、上面にできた皮を細い竹で引き上げて作る。中国が起源で、禅宗の僧によって伝えられたといわれる。湯せんの時間を見計らって作り分ける。',
    source:
      'https://plus.kyoto.travel/entry/kyotofoodculture2_kihon',
    icon: { label: '湯葉丼', shape: 'rice-bowl', baseColor: '#f0e0a8', accentColor: '#7ab048' },
    reward: {
      unlockScore: 6500,
      area: '京都市',
      headline: '豆乳から引き上げた湯葉をのせる',
      tip: '朝一番に作る汲み上げ湯葉、引き上げ湯葉、乾かした干し湯葉などの種類がある。最初にできる湯葉は、大豆の香りを味わうため、そのまま醤油をたらして食べるとよいとされる。',
      links: searchLinks('京都市', '湯葉丼'),
      official: [{ label: '京都市観光協会「京の食文化～普段のごはんからハレの日のごちそうまで～」', url: 'https://plus.kyoto.travel/entry/kyotofoodculture1_kihon' }],
    },
  },
  {
    id: 'tango-barazushi',
    level: 8,
    name: '丹後ばらずし',
    shortName: '丹後ばらずし',
    image: '/assets/foods/kyoto/08_tango_barazushi.webp',
    radius: 51,
    mass: 5.4,
    score: 256,
    description: 'まつぶたという浅い木箱に酢飯を敷き、甘辛く炒り煮にしたサバのおぼろを散らす。干ししいたけや錦糸卵、かまぼこ、紅しょうがなどを彩りよく並べ、二段にすることもある。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/barazushi_kyoto.html',
    icon: { label: 'ばらずし', shape: 'rice-bowl', baseColor: '#c89a68', accentColor: '#f0d040' },
    reward: {
      unlockScore: 9000,
      area: '京丹後市ほか丹後地域',
      headline: 'サバのおぼろを散らすすし',
      tip: '冷蔵の技術がない時代、若狭湾のサバは焼くか塩漬けにして保存した。名前は具やおぼろをすし飯の上にバラバラと散らすから、という説が有力とされる。',
      links: searchLinks('京丹後市', '丹後ばらずし'),
    },
  },
  {
    id: 'nishin-soba',
    level: 9,
    name: 'にしんそば',
    shortName: 'にしんそば',
    image: '/assets/foods/kyoto/09_nishin_soba.webp',
    radius: 57,
    mass: 6.6,
    score: 512,
    description: '北前船で北海道から運ばれた身欠きにしんは、内陸で魚介が手に入りにくい京都で重用され、欠かせない伝統食材になった。そのにしんを、そばに盛り付けたのがにしんそば。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/nishinnasu_kyoto.html',
    icon: { label: 'にしんそば', shape: 'noodle-bowl', baseColor: '#8a6a48', accentColor: '#5a2e18' },
    reward: {
      unlockScore: 12000,
      area: '京都市',
      headline: '北前船のにしんをそばにのせる',
      tip: '京都のにしんそばは、昆布と薄口醤油を使った薄い味付けとされる。北海道でも昔から食べられてきたが、こちらは濃口で汁がほのかに甘い。',
      links: searchLinks('京都市', 'にしんそば'),
      official: [{ label: '京都市観光協会「京の食文化～普段のごはんからハレの日のごちそうまで～」', url: 'https://plus.kyoto.travel/entry/kyotofoodculture1_kihon' }],
    },
  },
  {
    id: 'yudofu',
    level: 10,
    name: '湯豆腐',
    shortName: '湯豆腐',
    image: '/assets/foods/kyoto/10_yudofu.webp',
    radius: 63,
    mass: 8,
    score: 1024,
    description: '京の冬の名物料理として知られ、豆腐そのもののおいしさを味わう食べ方。京都でおいしい豆腐が作られてきたのは、良質な地下水に恵まれ、豆腐を伝えた寺院が多かったためとよく言われる。',
    source:
      'https://plus.kyoto.travel/entry/kyotofoodculture2_kihon',
    icon: { label: '湯豆腐', shape: 'hotpot', baseColor: '#f4f0e6', accentColor: '#3a5a3a' },
    reward: {
      unlockScore: 16000,
      area: '京都市',
      headline: '豆腐そのものを味わう冬の鍋',
      tip: '京都では名の通った豆腐店のほか、各町内に地域に根ざした豆腐屋があり、なじみの店で買うことが多いという。',
      links: searchLinks('京都市 南禅寺', '湯豆腐'),
    },
  },
  {
    id: 'saba-zushi',
    level: 11,
    name: 'さばずし',
    shortName: '鯖寿司',
    image: '/assets/foods/kyoto/11_saba_zushi.webp',
    radius: 70,
    mass: 9.6,
    score: 2048,
    description: '海のない都まで、鯖は歩いてきた。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/sabazushi_kyoto.html',
    icon: { label: '鯖寿司', shape: 'feast', baseColor: '#4a5a68', accentColor: '#f0ece0' },
    reward: {
      unlockScore: 22000,
      area: '京都市（伝承地域は府内全域）',
      headline: '塩鯖を酢で締めて棒状に握り、竹の皮で包んで一晩おく京都の祭りのごちそう。輪切りにして供す。',
      tip: '若狭湾で獲れた鯖を塩漬けにして運ぶと、京都に着くころにちょうどよい塩加減になったという経験から、江戸時代に今のつくり方が定まったと伝わる。葵祭・祇園祭・時代祭や秋祭りに食べる風習がある。',
      links: searchLinks('京都市', '鯖寿司'),
    },
  },
  {
    id: 'hamo-yakimono',
    level: 12,
    name: 'はもの焼き物',
    shortName: 'はも焼き',
    image: '/assets/foods/kyoto/12_hamo_yakimono.webp',
    radius: 78,
    mass: 11.4,
    score: 4096,
    description: '骨切りを覚えて、ようやく一人前。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/hamonoyakimono_kyoto.html',
    icon: { label: 'はも焼き', shape: 'fish', baseColor: '#f0e8d8', accentColor: '#a05a28' },
    reward: {
      unlockScore: 30000,
      area: '京都市・中丹地域・丹後地域',
      headline: '骨切りしたハモを串に打ち、たれをかけながら焼き上げる。祇園祭は「はも祭り」とも呼ばれる。',
      tip: 'ハモは生命力が強く遠方からも生きたまま運べたことが、京都での定着につながったとされる。骨切りには熟達した技術が要り、京都の料理人は骨切りを覚えてから一人前と言われる。',
      links: searchLinks('京都市', 'はも 焼き物'),
    },
  },
];

/** 得点は 2 ^ level を基準にしている（GAME_TUNING.score で方式変更可能）。 */
export const kyotoFoodStage: StageDefinition = {
  regionId: 'kyoto',
  regionName: '京都府',
  mode: 'food',
  title: '京都めしマージ',
  theme: {
    primaryColor: '#5a2a48',
    secondaryColor: '#c8a040',
    accentColor: '#e0c068',
    backgroundColor: '#161018',
  },
  /** 背景ツアー「京都めぐり」。軸は一日の時間。早朝の平等院から、夜の千本鳥居へ。 */
  scenery: {
    tour: kyotoSceneryTour,
  },
  items: attachHulls(FOOD_ITEMS, KYOTO_FOOD_HULLS),
};
